import(/* webpackMode: "eager" */ "/home/jenkins/workspace/appserver.deb/install/deb/debian/build/client/packages/doceditor/src/app/global-error.tsx");
